import type { FormKitNode } from '@formkit/core'

export default (node: FormKitNode): boolean => {
  const inputValue: string = node.value as string

  return /^\d+$/.test(inputValue)
}
